import { makeAutoObservable, runInAction } from 'mobx'
import { fetchOrganizationCounselors, fetchOrganizationRoles } from 'api/admin'
import { getAccessOptionsFromRoles, mapRoleToAccessLabel } from './userManagementMapping'

class CounselorsStore {
	counselors = []
	roles = []
	loadStatus = 'idle'
	error = null
	_inflight = null

	constructor() {
		makeAutoObservable(this, { _inflight: false }, { autoBind: true })
	}

	setCounselors(rows) {
		this.counselors = Array.isArray(rows) ? rows : []
	}

	get accessOptions() {
		return getAccessOptionsFromRoles(this.roles)
	}

	async ensureLoaded({ force = false } = {}) {
		if (!force && this.loadStatus === 'success') {
			return this.counselors
		}
		if (this._inflight) return this._inflight

		this.loadStatus = 'loading'
		this.error = null

		this._inflight = (async () => {
			try {
				const [counselorsPayload, rolesPayload] = await Promise.all([
					fetchOrganizationCounselors(),
					fetchOrganizationRoles(),
				])
				const rows = (counselorsPayload?.counselors || []).map(row => ({
					id: String(row.id || '').trim(),
					name: row.name || 'Unknown',
					email: row.email || '',
					roleId: row.role_id,
					role: row.role || '',
					access: mapRoleToAccessLabel(row.role),
					caseload: Number(row.caseload) || 0,
				}))
				const roles = (rolesPayload?.roles || []).map(row => ({
					id: row.id,
					name: row.name || '',
				}))
				runInAction(() => {
					this.counselors = rows
					this.roles = roles
					this.loadStatus = 'success'
				})
				return rows
			} catch (error) {
				runInAction(() => {
					this.loadStatus = 'error'
					this.error =
						error?.response?.data?.error ||
						error?.message ||
						'Failed to load counsellors'
				})
				throw error
			} finally {
				this._inflight = null
			}
		})()

		return this._inflight
	}
}

export const counselorsStore = new CounselorsStore()
